/*
Resize iframe when resize message is posted from the base origin
*/
import debounce from "lodash/debounce";
import Sb from "../abstract/StatefulBehavior";
import urlParse from "url-parse";

export default class ResizeIframe extends Sb {
  constructor(el, props, refs) {
    super();

    this.state = {
      iframeLoaded: false,
      height: 0,
    };

    this.props = props;
    this.iframe = refs.iframe;
    this.iframeError = refs.iframeError;

    if (!this.iframe.src) return null;
    this.baseUrlOrigin = urlParse(this.iframe.src).origin;

    this.bindEvents();
  }

  bindEvents() {
    if (window.addEventListener) {
      window.addEventListener("message", this.handleMessage, false);
    } else {
      window.attachEvent("onmessage", this.handleMessage);
    }
  }

  update = () => {
    const { height } = this.state;

    if (!this.iframe) return;

    Object.assign(this.iframe.style, {
      height: `${height}px`,
    });
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  handleMessage = debounce(({ data, origin }) => {
    if (
      this.baseUrlOrigin !== origin ||
      !data?.[0] ||
      origin !== "https://go.marinemammalcenter.org"
    )
      return;

    if (data[0] === "resize" && data[1]) {
      // Add a little extra padding to the height to prevent scroll bars
      this.setState({ height: Math.ceil(data[1]) + 20 });
      // The iframe loaded correctly if the resize event fired
      this.iframeError.classList.add("a-hidden");
      return;
    }

    if (data[0] === "scrollToTop") {
      this.scrollToTop();
    }
  }, 100);
}
